export default __webpack_public_path__ + "static/media/s4_female.56416e00.wav";